import React, { useState, useEffect } from 'react';
import Carousel from '../../components/Carousel';
import RestaurantCard from '../../components/RestaurantCard';

const HomePage = () => {
  const [featuredRestaurants, setFeaturedRestaurants] = useState([]);
  const [newRestaurants, setNewRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await fetch('https://food.mohamadmansour.me/api/restaurants');
        const data = await response.json();
  
        setFeaturedRestaurants(data.all);
        setNewRestaurants(data.new);
      } catch (error) {
        console.error("Error fetching restaurants:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchRestaurants();
  }, []);
  
  
  const carouselSlides = [
    {
      image: "/assets/images/c16.png",
      title: "Free Delivery on First Order",
      description: "Use code WELCOME at checkout"
    },
    {
      image: "/assets/images/c25.jpg",
      title: "30% Off on Selected Restaurants",
      description: "Limited time offer on premium dining"
    },
    {
      image: "/assets/images/c26.png",
      title: "Fresh & Healthy Meals",
      description: "Order healthy food from top restaurants"
    }
  ];
  
  return (
    <div className="home-page">
      <Carousel slides={carouselSlides} />
      
      <section className="featured-restaurants">
        <h2 className="section-title">Restaurants</h2>
        {loading ? (
          <div className="loading-spinner">Loading...</div>
        ) : (
          <div className="restaurant-grid">
            {featuredRestaurants.map(restaurant => (
              <RestaurantCard key={restaurant.id} restaurant={restaurant} />
            ))}
          </div>
        )}
      </section>
      
      <section className="new-restaurants">
        <h2 className="section-title">New on Food Delivery</h2>
        {loading ? (
          <div className="loading-spinner">Loading...</div>
        ) : (
          <div className="restaurant-grid">
            {newRestaurants.map(restaurant => (
              <RestaurantCard key={restaurant.id} restaurant={restaurant} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default HomePage;